angular.module('rjmNg.common.filters').filter "connectionCSSClass", [
  "connectionUtils"
  (
    connectionUtils
  ) ->

    connectionUtils.getCSSClass

]
